import { getCurrentUserId, getOrgId } from 'conversations/modules/user/selectors'
import { createSelector } from 'reselect'

import { RootState } from 'typesafe-actions'

export const getSocketSetupComplete = (state: RootState) => state.convo.socket.setupComplete

const ORG_CHANNEL = 'private-org-v2'
export const getOrgChannel = createSelector(getOrgId, (orgId) => `${ORG_CHANNEL}:${orgId}`)

const CONVO_CHANNEL = 'conversation-v2'

export const getConversationChannelPrefix = createSelector(
  getOrgId,
  (orgId) => `${CONVO_CHANNEL}:${orgId}`
)

const USER_SUBSCRIPTION_CHANNEL = 'user-subscription'
export const getUserSubscriptionChannel = (subscriptionId?: string) => (state: RootState) => {
  return `${USER_SUBSCRIPTION_CHANNEL}:${getOrgId(state)}-${getCurrentUserId(
    state
  )}-${subscriptionId}`
}
